const DestroyIFrame = (tag) => {
    const element = document.getElementById(tag)
    if (element) {
        element.remove()
    }
}

export default DestroyIFrame
